import { makeSelectedEvent } from 'app/pages/TicketSalePage/slice/selectors';
import { TicketSubtype } from 'app/pages/TicketSalePage/slice/types';
import React from 'react';
import { useSelector } from 'react-redux';
import { getFormattedSubtypesPriceRange } from 'utils/subtypes';

interface TicketSubtypesPriceRangeProps {
  subtypes: TicketSubtype[];
}

const TicketSubtypesPriceRange: React.FC<TicketSubtypesPriceRangeProps> = ({
  subtypes,
}) => {
  const event = useSelector(makeSelectedEvent);
  return (
    <div className="flex items-center h-fit w-fit absolute bottom-[8px] md:top-0 md:bottom-0 md:left-[unset] md:m-auto md:right-[12px]">
      <p className="p2-semibold">
        {getFormattedSubtypesPriceRange(event, subtypes, event.currency)}
      </p>
    </div>
  );
};

export default TicketSubtypesPriceRange;
